
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from "react-router-dom";
import logo from '../images/logo_text.png';
import TryButton from '../button/TryButton';
import { Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Spinner } from 'react-bootstrap';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';


export default function UserDetailPage() {
    const { userId } = useParams();

    const token = window.localStorage.getItem("token");

    const [formValues, setFormValues] = useState({
        name: '',
    });

    const [showTransfer, setShowTransfer] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showLoading, setShowLoading] = useState(false);


    const [userToTransfer, setUserToTransfer] = useState('');
    const [userList, setUserList] = useState({}); // {userId: {name, assignedCount, isAvailable}}

    const [userData, setUserData] = useState(null);
    const [assignations, setAssignations] = useState([]);  // [{attendeeId: {name, location}, group, status, time}]


    const [showConfirmation, setShowConfirmation] = useState(false);
    const [actionText, setActionText] = useState('');
    const [action, setAction] = useState(() => { });

    const [transferFormValues, setTransferFormValues] = useState({
        userToTransfer: '',
    });


    useEffect(() => {
        fetchUserData();

    }, []);

    const fetchAssignmentUsers = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + '/attendees/assignmentUsers', {
                params: { location: userData.location },
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            setUserList(response.data);
        } catch (error) {
            console.error("Error fetching assignment users:", error);
        }
    }

    const fetchUserData = () => {
        // Fetch user details from the backend API
        if (userId) {
            // Fetch the selected user data if an ID is stored
            axios.get(`${process.env.REACT_APP_API_URL}/auth/${userId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                setUserData(res.data);
                setFormValues({
                    name: res.data.name || '',
                });

            }).catch(err => {
                console.error("Error fetching selected user data:", err);
            });

            // Fetch user assignations
            axios.get(`${process.env.REACT_APP_API_URL}/auth/assignations/${userId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(res => {
                setAssignations(res.data);
            }).catch(err => {
                console.error("Error fetching user assignations:", err);
            });
        }
    }

    const handleEditRequest = (values, setSubmitting) => {
        setShowEdit(false);
        setShowLoading(true);
        axios.patch(`${process.env.REACT_APP_API_URL}/auth/${userId}`, values, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            setShowLoading(false);
            if (res.status === 200) {
                alert("Utilizatorul a fost editat cu succes!");
                fetchUserData();
            } else {
                alert("Utilizatorul a fost editat de altă persoană! Reîncărcați pagina și încercați din nou!");
            }
        }).catch(err => {
            console.error("Error editing user:", err);
            alert("Eroare la editarea utilizatorului. Vă rugăm să reîncărcați pagina și să încercați din nou.");
        }).finally(() => {
            setSubmitting(false);
        });
    }

    const handleTransfer = (values, setSubmitting) => {
        setShowTransfer(false);
        setShowLoading(true);

        const data = {
            fromUserId: userId,
            toUserId: values.userToTransfer,
        };

        axios.post(`${process.env.REACT_APP_API_URL}/auth/transferAssignations`, {
            fromUserId: userId,
            toUserId: values.userToTransfer,
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            setShowLoading(false);
            if (res.status === 200) {
                alert(res.data || "Programările au fost transferate cu succes!");
                // Refresh assignations
                axios.get(`${process.env.REACT_APP_API_URL}/auth/assignations/${userId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }).then(res => {
                    setAssignations(res.data);
                }).catch(err => {
                    console.error("Error fetching user assignations:", err);
                });
            }
        }).catch(err => {
            console.error("Error transferring assignations:", err);
            alert("Eroare la transferarea programărilor. Vă rugăm să reîncărcați pagina și să încercați din nou.");
        }).finally(() => {
            setSubmitting(false);
        });
    }

    const deleteUser = (userId) => {
        setShowLoading(true);
        axios.delete(`${process.env.REACT_APP_API_URL}/auth/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            setShowLoading(false);
            if (res.status === 200) {
                alert("Utilizatorul a fost șters cu succes!");
                window.location.href = '/users';
            } else {
                alert("Utilizatorul a fost șters de altă persoană! Reîncărcați pagina și încercați din nou!");
            }
        }).catch(err => {
            console.error("Error deleting user:", err);
            alert("Eroare la ștergerea utilizatorului. Vă rugăm să reîncărcați pagina și să încercați din nou.");
        });
    }

    return (
        <div className="page no-padding-top">
            <div className="d-flex mx-md-5 py-3 text-md-start justify-content-between ">
                <a href="/">
                    <img src={logo} className="logo-search" alt="Logo" />
                </a>
                <TryButton className='me-3 my-3'
                    onClick={() => window.history.back()}
                    text="Revenire" />
            </div>

            <div className='container d-flex justify-content-between '>
                {userData ? (
                    <>
                        <div className="">
                            <h4 className='text-center my-4'>Date</h4>

                            <h3>Nume: {userData.name}</h3>
                            <p>Locatia: {userData.location}</p>
                            <p>Tip: {(() => {
                                switch (userData.type) {
                                    case 'OWNER':
                                        return 'Proprietar';
                                    case 'ADMIN':
                                        return 'Administrator';
                                    case 'COACH':
                                        return 'Antrenor';
                                    default:
                                        return userData.type;
                                }
                            })()}</p>
                            <p>Username: {userData.username}</p>
                        </div>

                        <div className='d-flex flex-column align-items-center gap-3'>
                            <h4 className='text-center my-2'>Programari</h4>
                            <div className='d-flex flex-wrap gap-4 justify-content-center'>
                                {assignations.length > 0 ? assignations.map((assignation, index) => (
                                    assignation.assignments.map((attendeeAssignment, idx) => (
                                        <div key={idx} className="p-2 text-center border rounded"
                                            style={{ width: '18rem' }}
                                        >
                                            <h5>{attendeeAssignment.attendeeId.name}</h5>
                                            <p>Grupa: {assignation.group}</p>
                                            <p>Ora: {assignation.time}</p>
                                            <p>Status: {attendeeAssignment.status}</p>
                                            <p>Tip: {assignation.membershipType}</p>
                                        </div>

                                    ))
                                )) : (<p className='text-center'>Nu există programări pentru acest utilizator.</p>)}
                            </div>
                        </div>
                    </>
                ) : (
                    <p>Loading user details...</p>
                )}

            </div>

            <div className='d-flex justify-content-center flex-wrap py-4'>
                <TryButton type="button" className='m-auto mx-2 mx-md-3 my-2 d-inline' onClick={() => {
                    setShowEdit(true);
                    setShowConfirmation(false);
                }} text="Editează" />
                <TryButton type="button" className='m-auto mx-2 mx-md-3 my-2 d-inline'
                    onClick={() => {
                        setShowTransfer(true)
                        fetchAssignmentUsers();
                    }}
                    text="Transfera programarile" />

                <TryButton type="button" className='m-auto mx-2 mx-md-3 my-2 d-inline' onClick={() => {
                    setShowConfirmation(true);
                    setActionText("stergeti utilizatorul");
                    setAction(() => () => { deleteUser(userId); setShowConfirmation(false); });
                }} text="Sterge" />
            </div>

            <Modal show={showEdit} onHide={() => setShowEdit(false)} backdrop="static">
                <Modal.Header className='bg-black border border-danger' closeButton closeVariant='white'>
                    <h1 className='text-light'>Editează utilizator</h1>
                </Modal.Header>

                <Modal.Body className='bg-black border border-danger'>
                    <Formik
                        initialValues={formValues}
                        validate={values => {
                            const errors = {};
                            if (!values.name) {
                                errors.name = 'Câmp obligatoriu!';
                            }
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            setFormValues(values);

                            // Check if edited before
                            let edited = false;
                            axios.get(`${process.env.REACT_APP_API_URL}/auth/${userId}`, {
                                headers: {
                                    Authorization: `Bearer ${token}`
                                }
                            }).then(res => {
                                const currentData = res.data;

                                for (let key in currentData) {
                                    if (Array.isArray(currentData[key]) && Array.isArray(userData[key])) {
                                        if (currentData[key].length !== userData[key].length) {
                                            edited = true;
                                            break;
                                        }
                                        if (JSON.stringify(currentData[key]) !== JSON.stringify(userData[key])) {
                                            edited = true;
                                            break;
                                        }

                                    } else if (typeof currentData[key] === 'object' && currentData[key] !== null && userData[key] !== null) {
                                        // If object, compare JSON strings
                                        if (JSON.stringify(currentData[key]) !== JSON.stringify(userData[key])) {
                                            edited = true;
                                        }
                                    } else if (currentData[key] !== userData[key]) {
                                        edited = true;
                                        break;
                                    }
                                }

                                if (!edited) {
                                    // values.userId = userId; // Add userId to values
                                    handleEditRequest(values, setSubmitting);
                                } else {
                                    alert("Utilizatorul a fost editat de altă persoană! Reîncărcați pagina și încercați din nou!");
                                    setSubmitting(false);
                                }
                            }).catch(err => {
                                console.error("Error checking for edits:", err);
                                alert("Eroare la verificarea modificărilor. Vă rugăm să reîncărcați pagina și să încercați din nou.");
                                setSubmitting(false);
                            }
                            );
                        }}
                    >
                        {({ values, isSubmitting, setFieldValue }) => (
                            <Form className='text-light m-auto w-100 mt-3 px-2'>
                                <div className='mb-3'>
                                    <label htmlFor="name" className="form-label text-light">Nume Utilizator</label>
                                    <Field type="text" name="name" placeholder="Hatz Hatzulescu Jr." className="form-control animate__shakeX" id="name" />
                                    <ErrorMessage name="name" component="div" className="invalid-feedback" />
                                </div>

                                <TryButton type="submit" disabled={isSubmitting} className='mt-4 m-auto d-block' text="Editează" />
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>

            {/* Transfer */}
            <Modal show={showTransfer} onHide={() => setShowTransfer(false)}>
                <Modal.Header className='bg-black border border-danger' closeButton closeVariant='white'>
                    <Modal.Title className='text-light'>Transfera asignarile</Modal.Title>
                </Modal.Header>
                <Modal.Body className='bg-black border border-danger'>
                    <Formik
                        initialValues={transferFormValues}
                        validate={values => {
                            const errors = {};
                            if (!values.userToTransfer) {
                                errors.userToTransfer = 'Câmp obligatoriu!';
                            }
                            return errors;
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                            setTransferFormValues(values);
                            handleTransfer(values, setSubmitting);
                        }}
                    >
                        {({ values, isSubmitting, setFieldValue }) => (
                            <Form className='text-light m-auto w-100 mt-3 px-2'>
                                <div className='coach-assign mb-3'>

                                    <div className="d-flex align-items-center mb-2">
                                        <span className="text-light me-3" style={{ minWidth: '60px' }}>Transfera la</span>
                                        <DropdownButton
                                            onSelect={(e) => {
                                                setUserToTransfer(e);
                                                setFieldValue('userToTransfer', e);
                                            }}
                                            title={!userToTransfer ? "Selectează antrenorul" : `${userList[userToTransfer].name}`}
                                            size="lg" variant="light"
                                        >
                                            <Dropdown.Item eventKey="">Niciunul</Dropdown.Item>
                                            {Object.keys(userList).map((coachId) => {
                                                const coach = userList[coachId];
                                                return <Dropdown.Item eventKey={coachId} key={coachId}
                                                >
                                                    {coach.name}
                                                </Dropdown.Item>;
                                            })}
                                        </DropdownButton>
                                    </div>
                                    <ErrorMessage name="userToTransfer" component="div" className="invalid-feedback" />
                                </div>

                                <TryButton type="submit" disabled={isSubmitting} className='mt-4 m-auto d-block' text="Transferă" />
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>

            {/* Loading Screen */}
            {showLoading &&
                <div className='d-flex justify-content-center align-items-center' style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: '1060', display: 'none', backdropFilter: 'blur(1px)' }}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            }

            <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmare acțiune</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Sigur doriți să {actionText}?</p>
                    <div className="d-flex justify-content-end">
                        <TryButton text="Nu" onClick={() => setShowConfirmation(false)} className="mx-3" />
                        <TryButton text="Da" className="greenButton" onClick={() => { action(); }} />
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    )
}